export default "__VITE_PUBLIC_ASSET__8831eb72__"